<template>
    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <h4><b>Customer Detail</b></h4>
          <md-field>
            <label for="name">Customer Name</label>
            <md-input
              v-model="name"
              id="name"
              disabled
            ></md-input>
          </md-field>
          <md-field>
            <label for="email">Customer Email</label>
            <md-input
              v-model="email"
              id="email"
              disabled
            ></md-input>
          </md-field>
          <md-field>
            <label>Customer Phone Number</label>
            <md-input
              v-model="phone"
              id="phone"
              disabled
            ></md-input>
          </md-field>
        </form>
      </div>
      <md-snackbar
        md-position="center"
        :md-duration="6000"
        :md-active.sync="snackBar.show"
        md-persistent
      >
        <span>{{ snackBar.message }}</span>
      </md-snackbar>
    </div>
  </template>

<script>
import http from '../../../utils/Http.util';

export default {
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  mounted() {
    this.getCustomerDetail();
  },
  methods: {
    async getCustomerDetail() {
      this.$store.commit('busyStatus', true);
      try {
        const userID = this.$route.query.queryId;
        const result = await http.authReq(`/dashboard/customers/${userID}`);
        this.name = result.data.customer.name;
        this.phone = result.data.customer.phone;
        this.email = result.data.customer.email || 'null';
        this.$store.commit('busyStatus', false);
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.snackBar = {
          show: true,
          message: 'Unable to Get User Detail',
        };
      }
    },
  },
};
</script>

  <style scoped>
  .md-card-header {
    background: transparent !important;
    font-weight: 500;
  }
  </style>
